<div id="bubble_map" class="w-100 position-relative" style="height: 100vh; position: relative;">

    <div id="map_tooltips" class="bg-dark p-2 rounded"></div>

</div>


<div class="modal fade" id="view_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> جزئیات بیشتر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="">

                    <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

                    <div class="section border border-2 mt-2">

                        <table class="table table-striped bg-white mt-1 dirI" id="excel-list">

                            <thead>

                                <tr class="text-center">

                                    <th scope="col"> # </th>

                                    <th scope="col"> راننده </th>

                                    <th scope="col"> تاریخ </th>

                                    <th scope="col"> ساعت شروع </th>

                                    <th scope="col"> ساعت پایان </th>

                                    <th scope="col"> مقدار تخلیه(لیتر) </th>

                                    <th scope="col"> سرعت </th>

                                    <th scope="col"> آدرس </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="f14 text-center" *ngFor="let item of lst_Analyze;let i=index">

                                    <th class="text-dark"> {{ i + 1 | faNum}} </th>

                                    <th class="text-dark"> {{ item.strFullName | faNum}} </th>

                                    <th class="text-dark"> {{ item.strDate | faNum}} </th>

                                    <th class="text-dark"> {{ item.strSTime | faNum}} </th>

                                    <th class="text-dark"> {{ item.strETime | faNum}} </th>

                                    <th class="text-dark"> {{ item.fDischargeValue | number | faNum}} </th>

                                    <th class="text-dark"> {{ item.iSpeed | faNum}} </th>

                                    <th class="text-dark"> {{ item.strAddress | faNum}} </th>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>